import React from "react";
import { default as MuiGrid } from "@mui/material/Grid";

function Grid(props) {
  return <MuiGrid {...props} />;
}

export default Grid;
